import { render, staticRenderFns } from "./EditQuiz.vue?vue&type=template&id=75385469&scoped=true&"
import script from "./EditQuiz.vue?vue&type=script&lang=js&"
export * from "./EditQuiz.vue?vue&type=script&lang=js&"
import style0 from "./EditQuiz.vue?vue&type=style&index=0&id=75385469&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75385469",
  null
  
)

export default component.exports